import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSchool(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        d="M13.34 8.714V5.526l.66-.405m0 0L8.106 3 2 5.121l3.053 1.745M14 5.12l-2.841 1.745m-6.106 0 3.053 1.848 3.053-1.848m-6.106 0s-.144 2.029.397 3.753C5.85 11.893 6.798 13 8.106 13s2.256-1.107 2.656-2.381c.541-1.724.397-3.753.397-3.753"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSchool);
export default ForwardRef;
